"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTimeout = void 0;
var _react = require("react");
var _logger = require("../logger");
/**
 * This setTimeout functionality wrapper uses refs to store the current
 * callback and timeout ID, thus causing no unintentional re-renders.
 * @param callback Custom logic to be called.
 * @param delay Callback execution delay in milliseconds.
 * @returns Object with set and clear methods working with the scheduled timeout.
 */ const useTimeout = (initialSettings)=>{
    const settings = (0, _react.useRef)({
        id: undefined,
        shouldClearOnUnmount: true,
        ...initialSettings
    }).current;
    // clears the timeout
    const clear = (0, _react.useCallback)(()=>{
        if ("object" === 'object' && settings.id !== undefined) {
            window.clearTimeout(settings.id);
            (0, _logger.logDebug)("Cleared timeout ".concat(settings.id, "."));
            settings.id = undefined;
        }
    }, [
        settings
    ]);
    const setSettings = (0, _react.useCallback)((newSettings)=>{
        if (typeof (newSettings === null || newSettings === void 0 ? void 0 : newSettings.callback) === 'function') {
            settings.callback = newSettings.callback;
        }
        if (typeof (newSettings === null || newSettings === void 0 ? void 0 : newSettings.delay) === 'number') {
            settings.delay = newSettings.delay;
        }
        if (typeof (newSettings === null || newSettings === void 0 ? void 0 : newSettings.shouldClearOnUnmount) === 'boolean') {
            settings.shouldClearOnUnmount = newSettings.shouldClearOnUnmount;
        }
    }, [
        settings
    ]);
    // sets the timeout
    const set = (0, _react.useCallback)((newSettings)=>{
        clear();
        setSettings(newSettings);
        if ("object" === 'object') {
            settings.id = window.setTimeout(()=>{
                var _settings_callback;
                return (_settings_callback = settings.callback) === null || _settings_callback === void 0 ? void 0 : _settings_callback.call(settings);
            }, settings.delay);
            (0, _logger.logDebug)("Set timeout ".concat(settings.id, ", will execute in ").concat(settings.delay, " ms."));
        } else {
            (0, _logger.logWarning)("Can't set timeout ATM, window object is not defined.");
        }
    }, [
        clear,
        setSettings,
        settings
    ]);
    // does cleanup on unmount by default
    (0, _react.useEffect)(()=>()=>{
            if (settings.shouldClearOnUnmount) {
                clear();
            }
        }, [
        clear,
        settings
    ]);
    return {
        clear,
        set
    };
};
exports.useTimeout = useTimeout;
